import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import UserSummaryTable from './UserSummaryTable';
import Leaderboard from './Leaderboard';
import NewLeaderboard from './NewLeaderboard';
import DeviareLeaderboard from './DeviareLeaderboard';
import { partnerIds } from '../../../../constants/common';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Index({ batchData }) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const startDate = batchData.startDate;
  const isNewVga = new Date('2023-04-30T00:30:00.000Z') < new Date(startDate);

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label=''>
          <Tab label='User Details' {...a11yProps(0)} />
          <Tab label='Leaderboard' {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <UserSummaryTable batchData={batchData} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        {isNewVga ? (
          batchData.partner === partnerIds.deviare ? (
            <DeviareLeaderboard batchData={batchData} />
          ) : (
            <NewLeaderboard batchData={batchData} />
          )
        ) : (
          <Leaderboard batchData={batchData} />
        )}
      </TabPanel>
    </Box>
  );
}
